import queryString from "query-string";
import React, { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Container } from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";

import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import PlaceDetails from "../../Components/Places/PlaceDetails";
import { getTouristReceptionRequest } from "../../store/touristReceptions/actions";
import InfoTouristReception from "./components/InfoTouristReception";

const TouristReceptionDetails = () => {
  document.title = "Receptivos Turísticos | Ecoguias - Admin Dashboard";

  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { data, loading, success } = useSelector(
    (state) => state.TouristReception
  );

  const { search } = useLocation();
  const queryStringParams = queryString.parse(search);

  // const [dispatchDelete, setDispatchDelete] = useState(false);

  useEffect(() => {
    dispatch(getTouristReceptionRequest(id));
  }, [id, dispatch]);

  function renderPlaceDetails() {
    if (!data?.result) {
      return null;
    }

    return (
      <PlaceDetails
        loading={loading}
        data={data?.result?.receptionTourist}
        images={data?.result?.images}
        pathPaginationName="/tourist-reception"
        page={queryStringParams.page}
        menu={<InfoTouristReception data={data?.result?.receptionTourist} />}
      />
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Receptivos Turísticos" pageTitle="Locais" />
        </Container>

        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="p-4">
              <button
                className="btn btn-primary"
                onClick={() => history.goBack()}
              >
                Voltar
              </button>
            </div>
            {renderPlaceDetails()}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default TouristReceptionDetails;
